import React from "react";
import LegalLayout from "../components/LegalLayout";

const SecurityPage: React.FC = () => (
  <LegalLayout
    title="Security"
    path="/security"
    description="Security practices and features that help protect PABS accounts and data."
    intro="Practices and features that help protect PABS accounts and data."
  >
        <p>
          PABS is designed with security in mind. This page summarizes security practices and features that help
          protect accounts and data.
        </p>

        <h2>What we do</h2>
        <ul>
          <li>Use HTTPS to encrypt data in transit.</li>
          <li>Use access controls to restrict internal access to systems and data.</li>
          <li>Monitor for suspicious activity and abuse.</li>
          <li>Maintain backups and operational safeguards.</li>
        </ul>

        <h2>What you can do</h2>
        <ul>
          <li>Sign in with Google, Apple, or your phone number, and keep your 4-digit PIN to yourself.</li>
          <li>Never share the 6-digit SMS code. PABS staff will never ask for it.</li>
          <li>Be careful with shared links, third-party integrations, and browser extensions.</li>
          <li>Report suspicious activity promptly.</li>
        </ul>

        <h2>Related pages</h2>
        <p>
          See our <a href="/privacy">Privacy Statement</a> and <a href="/cookies">Cookies Notice</a>.
        </p>

        <h2>Contact</h2>
        <p>
          For security concerns, use <a href="/contact">Contact</a>.
        </p>

        <p className="legal-note">
          This page is provided for general informational purposes and may be updated from time to time.
        </p>
  </LegalLayout>
);

export default SecurityPage;
